module.exports = __webpack_public_path__ + "img/in-Progress.2c043707.svg";